export const paths = [
  { path: "/", label: "Dashboard" },
  { path: "/borrow", label: "Borrow" },
  { path: "/farm", label: "Farm" },
  { path: "/veYETI", label: "veYETI" },
  { path: "/more", label: "More" }
];
